export default __webpack_public_path__ + "397392af319e9c327a3b7d55f97b501b.png";